import Cookies from 'js-cookie';

import storage from './storage';
import { filters } from '../shared/filters/filters';

/**
 * Clears persisted auth without navigating away.
 * Used after a successful invitation set-password so a previous browser session
 * cannot be restored on refresh, while failed attempts stay on the form.
 */
export const clearPersistedAuthSession = () => {
  storage.remove('user');
  storage.remove('timezone');
  storage.remove('subscription');
  storage.remove('device_token');
  storage.remove('isNotificationBlocked');
  Cookies.remove('user_type');
  Cookies.remove('access_token');

  Object.values(filters).forEach((filter) => {
    filter.clearPersistedValue();
  });
};
